
import { mapGetters } from "vuex";
import NoDataLabel from "../common/no-data-label.vue";
import menuItemRowWithPriceAndSwitch from "./menu-item-row-with-price-and-switch.vue";
export default {
  components: { menuItemRowWithPriceAndSwitch, NoDataLabel },
  data() {
    return {
      active: [],
      renderItems: [],
      intersectionOptions: {
        root: null,
        rootMargin: "0px 0px 0px 0px",
        threshold: [0, 1]
      }
    };
  },
  computed: {
    ...mapGetters("menu", ["getSoldOutList"])
  },
  watch: {
    getSoldOutList() {
      this.addRenderItems();
    }
  },
  methods: {
    addRenderItems() {
      // this.renderItems.push(
      //   ...this.getSoldOutList.slice(
      //     this.renderItems.length,
      //     this.renderItems.length + 10
      //   )
      // );
      this.renderItems = this.getSoldOutList.slice(
        0,
        this.renderItems.length + 10
      );
    },
    onWaypoint({ going, direction }) {
      if (going === "in") {
        this.addRenderItems();
      }
    }
  }
};
